module.exports = __webpack_public_path__ + "static/shipkoo-1-choice-of-us-importers-97fa8b9cf0072cd3b172b94fe0c082f0.png";